module.exports = __webpack_public_path__ + "static/media/bill.781ce2b1.svg";